<tlv-header [name]="userName"></tlv-header>

<div *ngFor="let message of (messages$ | async)"><tlv-message *ngIf="message"
               [message]="message"></tlv-message></div>
<div class="container"><router-outlet></router-outlet></div>
<!-- TODO: add ngIf Organization from server is EPS -->
<!-- <tlv-footer></tlv-footer> -->